import React, { useEffect, useState } from 'react';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { FalseSolutions } from './components/FalseSolutions';
import { AuthorSection } from './components/AuthorSection';
import { MechanismReveal } from './components/MechanismReveal';
import { BonusSection } from './components/BonusSection';
import { WeeklyBreakdown } from './components/WeeklyBreakdown';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { LegalModal } from './components/LegalModal';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ViewersBar } from './components/ViewersBar';
import { initPixel, trackPageView } from './utils/pixel';
type ModalType = 'privacy' | 'terms' | null;
export function App() {
  const [legalModal, setLegalModal] = useState<ModalType>(null);
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-[#FDFAF7] font-sans text-[#1C1C2E] overflow-x-hidden pt-[45px]" data-id="element-0">
      <OfferBar data-id="element-1" />
      <ProgressBar data-id="element-2" />

      <HeroSection data-id="element-3" />
      <PainAgitation data-id="element-4" />
      <FalseSolutions data-id="element-5" />
      <MechanismReveal data-id="element-6" />
      <WeeklyBreakdown data-id="element-7" />
      <BonusSection data-id="element-8" />
      <OfferSection id="comprar" showUrgency={true} showCountdown={false} showGuarantee={true} showPayment={true} data-id="element-9" />

      <AuthorSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <UrgencySection data-id="element-13" />
      <FinalOfferSection data-id="element-14" />
      <FaqSection data-id="element-15" />

      <footer className="bg-[#1C1C2E] text-[#EEF2F7] text-center py-12 px-4 text-xs border-t border-[#4A4A6A]" data-id="element-16">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-17">
          <p className="font-serif text-lg text-[#FDFAF7]" data-id="element-18">
            El Apoyo Incondicional
          </p>
          <p className="text-[#8B8BAA] italic" data-id="element-19">
            Una guía para las familias que enfrentan el cáncer juntas.
          </p>

          <div className="flex justify-center gap-6 flex-wrap text-[#8B8BAA]" data-id="element-20">
            <button onClick={() => setLegalModal('privacy')} className="hover:text-[#EEF2F7] transition-colors underline underline-offset-2" data-id="element-21">
              Política de Privacidad
            </button>
            <span className="text-[#4A4A6A]" data-id="element-22">|</span>
            <button onClick={() => setLegalModal('terms')} className="hover:text-[#EEF2F7] transition-colors underline underline-offset-2" data-id="element-23">
              Términos de Servicio
            </button>
          </div>

          <p className="mb-4 text-[#8B8BAA]" data-id="element-24">
            © 2025 El Apoyo Incondicional. Todos los derechos reservados.
          </p>

          <p className="max-w-2xl mx-auto leading-relaxed text-[#4A4A6A]" data-id="element-25">
            Descargo de responsabilidad: Este producto es de carácter educativo
            e informativo. No reemplaza la atención médica profesional, el
            diagnóstico o el tratamiento. Siempre consulta a un profesional de
            la salud calificado para cualquier pregunta que puedas tener sobre
            una condición médica.
          </p>
        </div>
      </footer>

      <LegalModal open={legalModal} onClose={() => setLegalModal(null)} data-id="element-26" />
      <SocialProofPopup data-id="element-27" />
      <ViewersBar data-id="element-28" />
    </main>;
}